/* v2026040402 */
(function(){
  function addTrustBar() {
    if (!window.location.pathname.includes('/products/')) return;
    
    var trustHTML = '<div id="makne-trust-bar" style="margin:20px 0;padding:16px;background:linear-gradient(135deg,#fff5f5,#fff);border:1px solid #ffe0e0;border-radius:12px;font-family:system-ui,sans-serif">' +
      '<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;padding-bottom:10px;border-bottom:1px solid #ffe8e8">' +
        '<span style="font-size:16px">🏆</span>' +
        '<span style="font-size:14px;font-weight:700;color:#333">Trusted by 1M+ Happy Customers on TikTok Thailand</span>' +
        '<span style="background:#ff4d6d;color:#fff;font-size:10px;padding:2px 8px;border-radius:10px;font-weight:600">VERIFIED</span>' +
      '</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">' +
        '<div style="display:flex;align-items:center;gap:8px;font-size:13px;color:#444"><span style="font-size:18px">💵</span><span><b>Cash on Delivery</b><br><span style="color:#e53e3e;font-size:11px;font-weight:600">Pay When You Receive</span></span></div>' +
        '<div style="display:flex;align-items:center;gap:8px;font-size:13px;color:#444"><span style="font-size:18px">🚚</span><span><b>Free Shipping</b><br><span style="color:#888;font-size:11px">All Over India</span></span></div>' +
        '<div style="display:flex;align-items:center;gap:8px;font-size:13px;color:#444"><span style="font-size:18px">🔒</span><span><b>Secure Checkout</b><br><span style="color:#888;font-size:11px">100% Safe Payment</span></span></div>' +
        '<div style="display:flex;align-items:center;gap:8px;font-size:13px;color:#444"><span style="font-size:18px">🌏</span><span><b>Made in Thailand</b><br><span style="color:#888;font-size:11px">Premium Products</span></span></div>' +
      '</div>' +
    '</div>';

    var targets = [
      'form[action*="/cart/add"]',
      '.product-form',
      '.product__info-wrapper',
      '[data-product-form]'
    ];
    
    var inserted = false;
    for (var i = 0; i < targets.length; i++) {
      var el = document.querySelector(targets[i]);
      if (el) {
        el.insertAdjacentHTML('afterend', trustHTML);
        inserted = true;
        break;
      }
    }
    
    if (!inserted) {
      var desc = document.querySelector('.product__description') || document.querySelector('.product-single__description');
      if (desc) desc.insertAdjacentHTML('beforebegin', trustHTML);
    }
  }

  function addSocialProof() {
    if (document.getElementById('makne-social-proof')) return;
    var bar = document.createElement('div');
    bar.id = 'makne-social-proof';
    bar.style.cssText = 'background:#1a1a2e;color:#fff;text-align:center;padding:8px;font-size:13px;font-family:system-ui,sans-serif;';
    bar.innerHTML = '🎉 <b>COD Available</b> · Free Shipping All India · 1M+ Happy Customers · Made in Thailand';
    var firstChild = document.body.firstChild;
    if (firstChild) document.body.insertBefore(bar, firstChild);
  }

  // === ADD "How To" NAV ITEM ===
  function addHowToNav() {
    var navLists = document.querySelectorAll('nav ul, .header__menu ul, .site-nav, [role="navigation"] ul');
    navLists.forEach(function(ul) {
      if (ul.innerHTML.includes('/pages/how-to')) return;
      var items = ul.querySelectorAll('li');
      var contactItem = null;
      items.forEach(function(li) {
        if (li.textContent.trim().toLowerCase() === 'contact') {
          contactItem = li;
        }
      });
      if (contactItem && items.length >= 2) {
        var newLi = contactItem.cloneNode(true);
        var link = newLi.querySelector('a');
        if (link) {
          link.href = '/pages/how-to';
          link.textContent = 'How To';
        }
        contactItem.parentNode.insertBefore(newLi, contactItem);
      }
    });
  }

  // === COUNTDOWN TIMER — Introductory Offer ===
  function addCountdownTimer() {
    var isProduct = window.location.pathname.includes('/products/');
    var isHome = (window.location.pathname === '/' || window.location.pathname === '');
    if (!isProduct && !isHome) return;
    if (document.getElementById('makne-countdown')) return;

    var deadline = new Date('2026-04-30T23:59:59+05:30').getTime();

    var timerHTML = '<div id="makne-countdown" style="margin:16px 0;padding:14px 16px;background:linear-gradient(135deg,#1a1a2e,#16213e);border-radius:12px;font-family:system-ui,sans-serif;text-align:center;color:#fff">' +
      '<div style="font-size:13px;font-weight:700;color:#ffd700;margin-bottom:6px">⏰ APRIL OFFER — Ends April 30!!</div>' +
      '<div style="font-size:12px;color:#ccc;margin-bottom:10px">Regular price is <span style="text-decoration:line-through;color:#ff6b6b">₹699</span> per product after this</div>' +
      '<div id="makne-timer-digits" style="display:flex;justify-content:center;gap:8px">' +
        '<div style="background:rgba(255,255,255,0.1);border-radius:8px;padding:8px 12px;min-width:56px"><div id="makne-days" style="font-size:22px;font-weight:800;color:#ff4d6d">--</div><div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:1px">Days</div></div>' +
        '<div style="background:rgba(255,255,255,0.1);border-radius:8px;padding:8px 12px;min-width:56px"><div id="makne-hours" style="font-size:22px;font-weight:800;color:#ff4d6d">--</div><div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:1px">Hours</div></div>' +
        '<div style="background:rgba(255,255,255,0.1);border-radius:8px;padding:8px 12px;min-width:56px"><div id="makne-mins" style="font-size:22px;font-weight:800;color:#ff4d6d">--</div><div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:1px">Mins</div></div>' +
        '<div style="background:rgba(255,255,255,0.1);border-radius:8px;padding:8px 12px;min-width:56px"><div id="makne-secs" style="font-size:22px;font-weight:800;color:#ff4d6d">--</div><div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:1px">Secs</div></div>' +
      '</div>' +
      '<div style="margin-top:10px;font-size:12px;font-weight:600;color:#4ade80">🔥 April Special — Only Rs.499!</div>' +
    '</div>';

    // Insert before the trust bar or after the add-to-cart form
    var trustBar = document.getElementById('makne-trust-bar');
    if (trustBar) {
      trustBar.insertAdjacentHTML('beforebegin', timerHTML);
    } else if (isHome) {
      // On homepage, insert after the social proof bar or at the top of main content
      var socialBar = document.getElementById('makne-social-proof');
      if (socialBar) {
        socialBar.insertAdjacentHTML('afterend', timerHTML);
      } else {
        var main = document.querySelector('main') || document.querySelector('#MainContent') || document.querySelector('.shopify-section');
        if (main) main.insertAdjacentHTML('afterbegin', timerHTML);
      }
    } else {
      var targets = ['form[action*="/cart/add"]', '.product-form', '.product__info-wrapper'];
      for (var i = 0; i < targets.length; i++) {
        var el = document.querySelector(targets[i]);
        if (el) { el.insertAdjacentHTML('afterend', timerHTML); break; }
      }
    }

    // Tick every second
    function updateTimer() {
      var now = new Date().getTime();
      var diff = deadline - now;
      if (diff <= 0) {
        var container = document.getElementById('makne-countdown');
        if (container) container.innerHTML = '<div style="padding:10px;font-size:14px;font-weight:700;color:#ff4d6d">⏰ Introductory Offer is LIVE!</div>';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var de = document.getElementById('makne-days'); if(de) de.textContent = d < 10 ? '0'+d : d;
      var he = document.getElementById('makne-hours'); if(he) he.textContent = h < 10 ? '0'+h : h;
      var me = document.getElementById('makne-mins'); if(me) me.textContent = m < 10 ? '0'+m : m;
      var se = document.getElementById('makne-secs'); if(se) se.textContent = s < 10 ? '0'+s : s;
    }
    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // === REPLACE SHIPPING TEXT ===
  function replaceShippingText() {
    var links = document.querySelectorAll('a[href*="shipping"]');
    links.forEach(function(el) {
      var parent = el.closest('p') || el.closest('div') || el.parentElement;
      if (parent && parent.textContent.toLowerCase().includes('shipping') && parent.textContent.toLowerCase().includes('calculated')) {
        parent.innerHTML = '<span style="color:#e53e3e;font-weight:600;font-size:13px">🔥 Selling Fast · Free Delivery · COD Available</span>';
      }
    });
    document.querySelectorAll('.price__policies, .product__policies, [class*="shipping"]').forEach(function(el) {
      if (el.textContent.toLowerCase().includes('shipping') && el.textContent.toLowerCase().includes('calculated')) {
        el.innerHTML = '<span style="color:#e53e3e;font-weight:600;font-size:13px">🔥 Selling Fast · Free Delivery · COD Available</span>';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { addTrustBar(); addCountdownTimer(); addSocialProof(); replaceShippingText(); addHowToNav(); });
  } else {
    addTrustBar();
    addCountdownTimer();
    addSocialProof();
    replaceShippingText();
    addHowToNav();
  }
})()
